import { BrowserRouter as Router, Switch } from "react-router-dom";
import GeustRoute from "./helpers/authentication/geustRoute";
import Layout from "./components/layout/Layout";
import AuthRoute from "./helpers/authentication/authRoute";
import Login from "./views/authentication/Login";
import Home from "./views/Home";
import ModeratorsIndex from "./views/moderators/ModeratorsIndex";
import ModeratorsCreate from "./views/moderators/ModeratorsCreate";
import ModeratorShow from "./views/moderators/ModeratorShow";

import RealEstateIndex from "./views/products/RealEstateIndex";
import RealEstateCreate from "./views/products/RealEstateCreate";
import RealEstateShow from "./views/products/RealEstateShow";

import ServicesIndex from "./views/service/index";
import ServiceCreate from "./views/service/create";
import ServiceShow from "./views/service/show";

import CategoriesIndex from "./views/category/CategoriesIndex";
import CategoriesCreate from "./views/category/CategoriesCreate";
import CategoriesShow from "./views/category/CategoriesShow";

import TypeIndex from "./views/type/TypeIndex";
import TypeCreate from "./views/type/TypeCreate";
import TypeShow from "./views/type/TypeShow";

import ServicesApplications from "./views/services/ServicesApplications";
import ServiceShowApplication from "./views/services/ServiceShowApplication";

import ContactIndex from "./views/contact/ContactIndex";
import ContactShow from "./views/contact/ContactShow";
import SliderIndex from "./views/slider/SliderIndex";
import SliderCreate from "./views/slider/SliderCreate";
import SliderShow from "./views/slider/SliderShow";

// import LinksIndex from "./views/footerLinks/LinksIndex";
// import LinksCreate from "./views/footerLinks/LinksCreate";
// import LinksShow from "./views/footerLinks/LinksShow";

// import About from "./views/About";
import Settings from "./views/Settings";

import CommentsIndex from "./views/Comments/CommentsIndex";
import CommentsCreate from "./views/Comments/CommentsCreate";
import CommentsShow from "./views/Comments/CommentsShow";
import HeroSectionIndex from "./views/heroSection/HeroSectionIndex";
import HeroSectionCreate from "./views/heroSection/HeroSectionCreate";
import HeroSectionShow from "./views/heroSection/HeroSectionShow";
import AboutUsCreate from "./views/aboutPage/AboutUsCreate";
import AboutUsIndex from "./views/aboutPage/AboutUsIndex";
import AboutUsShow from "./views/aboutPage/AboutUsShow";
import WhyUsShow from "./views/whyUs/WhyUsShow";
import WhyUsIndex from "./views/whyUs/WhyUsIndex";
import LinksCreate from "./views/socials/links/LinksCreate";
import LinksIndex from "./views/socials/links/LinksIndex";
import SocialTypes from "./views/socials/types/SocialTypesIndex";
import SocialTypesCreate from "./views/socials/types/SocialTypesCreate";
import LinksShow from "./views/socials/links/LinksShow";
import LatestShow from "./views/projects/show";
import LatestIndex from "./views/projects";
import LatestCreate from "./views/projects/create";
import BrandsIndex from "./views/Brands/BrandsIndex";
import BrandsCreate from "./views/Brands/BrandsCreate";
import BrandsShow from "./views/Brands/BrandsShow";

function App() {
	return (
		<Router>
			<Switch>
				<GeustRoute path="/login" component={Login} />
				<Layout>
					<AuthRoute path="/" exact component={Home} />
					<AuthRoute path="/dashboard" component={Home} />
					<AuthRoute path="/moderators/index" component={ModeratorsIndex} />
					<AuthRoute path="/moderators/create" component={ModeratorsCreate} />
					<AuthRoute
						path="/moderators/show/:moderatorID"
						component={ModeratorShow}
					/>
					<AuthRoute path="/category/index" component={CategoriesIndex} />
					<AuthRoute path="/category/create" component={CategoriesCreate} />
					<AuthRoute
						path="/category/show/:categoryId"
						component={CategoriesShow}
					/>
					{/* <AuthRoute
						path="/social/socialType/index"
						component={SocialTypes}
						exact
					/>
					<AuthRoute
						path="/social/socialType/create"
						component={SocialTypesCreate}
						exact
					/> */}
					<AuthRoute path="/social/links/index" component={LinksIndex} />
					<AuthRoute path="/social/links/create" component={LinksCreate} />
					<AuthRoute path="/social/links/show/:linkId" component={LinksShow} />
					<AuthRoute path="/type/index" component={TypeIndex} />
					<AuthRoute path="/type/create" component={TypeCreate} />
					<AuthRoute path="/type/show/:typeId" component={TypeShow} />

					<AuthRoute path="/products/index" component={RealEstateIndex} />
					<AuthRoute path="/products/create" component={RealEstateCreate} />
					<AuthRoute
						path="/products/show/:realEstateId"
						component={RealEstateShow}
					/>

					<AuthRoute path="/latestProjects/index" component={LatestIndex} />
					<AuthRoute path="/latestProjects/create" component={LatestCreate} />
					<AuthRoute
						path="/latestProjects/show/:realEstateId"
						component={LatestShow}
					/>

					<AuthRoute path="/service/index" component={ServicesIndex} />
					<AuthRoute path="/service/create" component={ServiceCreate} />
					<AuthRoute
						path="/service/show/:realEstateId"
						component={ServiceShow}
					/>

					<AuthRoute
						path="/services/applications"
						component={ServicesApplications}
					/>
					<AuthRoute
						path="/services/application/:applicationID"
						component={ServiceShowApplication}
					/>
					<AuthRoute path="/orders/index" component={ContactIndex} />
					<AuthRoute path="/orders/show/:contactID" component={ContactShow} />
					<AuthRoute path="/settings" component={Settings} />
					<AuthRoute path="/slider/index" component={SliderIndex} />
					<AuthRoute path="/slider/create" component={SliderCreate} />
					<AuthRoute path="/slider/show/:slideID" component={SliderShow} />
					<AuthRoute path="/footerLinks/index" component={LinksIndex} />
					<AuthRoute path="/footerLinks/create" component={LinksCreate} />
					{/* <AuthRoute path="/footerLinks/show/:linkID" component={LinksShow} /> */}
					{/* Comments Section */}
					<AuthRoute path="/Comments/index" component={CommentsIndex} />
					<AuthRoute path="/Comments/create" component={CommentsCreate} />
					<AuthRoute path="/Comments/show/:centerID" component={CommentsShow} />
					{/* Comments End Here */}
					{/* Brands Section */}
					<AuthRoute path="/Brands/index" component={BrandsIndex} />
					<AuthRoute path="/Brands/create" component={BrandsCreate} />
					<AuthRoute path="/Brands/show/:centerID" component={BrandsShow} />
					{/* Brands End Here */}
					<AuthRoute
						path="/siteinfo/heroSection/create"
						component={HeroSectionCreate}
					/>
					<AuthRoute
						path="/siteinfo/heroSection/index"
						component={HeroSectionIndex}
					/>
					<AuthRoute
						path="/siteinfo/heroSection/show/:heroSectionId"
						component={HeroSectionShow}
					/>
					{/* <AuthRoute
						path="/siteinf o/aboutUs/create"
						component={AboutUsCreate}
					/> */}
					<AuthRoute path="/siteinfo/aboutUs/index" component={AboutUsIndex} />
					<AuthRoute
						path="/siteinfo/aboutUs/show/:aboutUsSectionId"
						component={AboutUsShow}
					/>
					<AuthRoute path="/siteinfo/whyUs/index" component={WhyUsIndex} />

					<AuthRoute
						path="/siteinfo/whyUs/show/:whyUsId"
						component={WhyUsShow}
					/>
				</Layout>
			</Switch>
		</Router>
	);
}

export default App;
